import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import FlutesPage from "@/pages/Flutes";
import DrumsPage from "@/pages/Drums";
import DidgeridoosPage from "@/pages/Didgeridoos";
import GalleryPage from "@/pages/Gallery";
import StoryPage from "@/pages/Story";
import StoriesPage from "@/pages/Stories";
import ConnectPage from "@/pages/Connect";
import CommissionsPage from "@/pages/Commissions";
import ContactPage from "@/pages/Contact";
import InstrumentDetail from "@/pages/InstrumentDetail";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/Layout";
import AdminInstruments from "@/pages/admin/Instruments";
import AdminContent from "@/pages/admin/Content";
import AdminInquiries from "@/pages/admin/Inquiries";
import AdminStories from "@/pages/admin/Stories";
import AdminMediaLinks from "@/pages/admin/MediaLinks";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/flutes" element={<FlutesPage />} />
          <Route path="/drums" element={<DrumsPage />} />
          <Route path="/didgeridoos" element={<DidgeridoosPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/story" element={<StoryPage />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/commissions" element={<CommissionsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/instrument/:id" element={<InstrumentDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminInstruments />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="stories" element={<AdminStories />} />
            <Route path="media" element={<AdminMediaLinks />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
